import { createContext, useContext, useState, useEffect } from 'react';

const AppContext = createContext(null);

export function AppProvider({ children }) {
  const [user, setUser] = useState(() => {
    const id = localStorage.getItem('userID');
    const nome = localStorage.getItem('userName');
    return id ? { ID_usuario: id, nome } : null;
  });

  const login = (userData, onNavigate) => {
    localStorage.setItem('userID', userData.ID_usuario);
    localStorage.setItem('userName', userData.nome);
    setUser(userData);
    onNavigate();
  };

  const logout = (onNavigate) => {
    localStorage.removeItem('userID');
    localStorage.removeItem('userName');
    setUser(null);
    onNavigate();
  };

  useEffect(() => {
    if (!user) return;

    let isActive = true;

    const checkSession = () => {
      console.log('[AppContext] checking session...');
      fetch('https://rvensino.com.br/get.php?action=check_session', { credentials: 'include' })
        .then(r => r.json())
        .then(data => {
          if (!isActive) return;
          console.log('[AppContext] check_session:', data);
          if (!data.logged_in) {
            console.log('[AppContext] session gone, redirecting to /login');
            localStorage.clear();
            window.location.href = '/login';
          }
        })
        .catch(err => console.error('[AppContext] check_session failed:', err));
    };

    // Check session on mount and then every 5 minutes
    checkSession();
    const interval = setInterval(checkSession, 300000); // 5 minutes
    return () => {
      isActive = false;
      clearInterval(interval);
    };
  }, [user]);


  return (
    <AppContext.Provider value={{ user, login, logout }}>
      {children}
    </AppContext.Provider>
  );
}

export function useApp() {
  return useContext(AppContext);
}
